import { render, staticRenderFns } from "./Borrador.vue?vue&type=template&id=4d5decbe&"
import script from "./Borrador.vue?vue&type=script&lang=js&"
export * from "./Borrador.vue?vue&type=script&lang=js&"
import style0 from "./Borrador.vue?vue&type=style&index=0&id=4d5decbe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports